import React from "react";

interface CountryDropdownProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  required?: boolean;
  id?: string;
  name?: string;
  label?: string;
  labelPaddingBottom?: number; // optional extra bottom padding on label
}

const hardcodedCountries = ["United Kingdom", "United States", "Canada"];
const additionalCountries = [
  "Afghanistan",
  "Akrotiri",
  "Aland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Ashmore and Cartier Islands",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Baker Island",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "British Virgin Islands",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Clipperton Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo (Congo-Brazzaville)",
  "Cook Islands",
  "Coral Sea Islands",
  "Costa Rica",
  "Cote D'Ivoire (Ivory Coast)",
  "Croatia",
  "Cuba",
  "Curacao",
  "Cyprus",
  "Czechia (Czech Republic)",
  "Democratic Republic of the Congo",
  "Denmark",
  "Dhekelia",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  'Eswatini (fmr. "Swaziland")',
  "Ethiopia",
  "Falkland Islands (Islas Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Metropolitan",
  "French Polynesia",
  "French Southern and Antarctic Lands",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Honduras",
  "Hong Kong",
  "Howland Island",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle Of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Jan Mayen",
  "Japan",
  "Jarvis Island",
  "Jersey",
  "Johnston Atoll",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kingman Reef",
  "Kiribati",
  "Korea, Democratic People's Republic of (North)",
  "Korea, Republic of (South)",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Midway Islands",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar (formerly Burma)",
  "Namibia",
  "Nauru",
  "Navassa Island",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "North Korea",
  "North Macedonia",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine State",
  "Palmyra Atoll",
  "Panama",
  "Papua New Guinea",
  "Paracel Islands",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn Islands",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Barthelemy",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Spratly Islands",
  "Sri Lanka",
  "St. Helena",
  "St. Pierre and Miquelon",
  "Sudan",
  "Suriname",
  "Svalbard",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks And Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Virgin Islands (U.S.)",
  "Wake Island",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Yugoslavia",
  "Zambia",
  "Zimbabwe",
  "Other",
];
const allCountries = [...hardcodedCountries, ...additionalCountries];

const CountryDropdown: React.FC<CountryDropdownProps> = ({
  value,
  onChange,
  required = false,
  id = "country-of-citizenship",
  name = "Country of citizenship",
  label = "Country of citizenship:",
  labelPaddingBottom = 0,
}) => {
  // Normalize country name for better matching
  const normalizeCountryName = (countryName: string): string => {
    if (!countryName || typeof countryName !== "string") return "";

    // Convert to proper case and handle common variations
    const normalized = countryName
      .trim()
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase()) // Convert to proper case
      .replace(/\bUsa\b/g, "United States")
      .replace(/\bUk\b/g, "United Kingdom")
      .replace(/\bNz\b/g, "New Zealand");

    // console.log(`🔍 Country normalization: "${countryName}" -> "${normalized}"`);
    return normalized;
  };

  // Normalize the input value
  const normalizedValue = normalizeCountryName(value);

  // Check if the normalized value exists in the country list (case-insensitive)
  const isValueInList =
    normalizedValue && typeof normalizedValue === "string"
      ? allCountries.some((country) => country.toLowerCase() === normalizedValue.toLowerCase())
      : false;

  // Find the exact match from the list to use as the select value
  const selectValue = isValueInList
    ? allCountries.find((country) => country.toLowerCase() === normalizedValue.toLowerCase()) || ""
    : "";

  const hasValue = normalizedValue && normalizedValue.trim() !== "";

  return (
    <div style={{ marginBottom: 16, width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
      <label
        htmlFor={id}
        style={{ display: "block", marginBottom: 4, paddingBottom: labelPaddingBottom }}
      >
        {label}
      </label>
      <select
        id={id}
        name={name}
        value={isValueInList ? selectValue : hasValue ? "OTHER_CUSTOM" : ""}
        onChange={onChange}
        style={{
          width: "100%",
          maxWidth: "100%",
          padding: "8px",
          borderRadius: 4,
          border: "1px solid #ccc",
          boxSizing: "border-box",
        }}
        required={required}
      >
        <option value="">---Select---</option>
        {hardcodedCountries.map((country) => (
          <option key={country} value={country}>
            {country}
          </option>
        ))}
        {/* Divider */}
        <option disabled>---</option>

        {/* Dynamically added countries */}
        {additionalCountries.map((country) => (
          <option key={country} value={country}>
            {country}
          </option>
        ))}

        {/* Show unmatched value as "Other" option */}
        {hasValue && !isValueInList && (
          <>
            <option disabled>---</option>
            <option value="OTHER_CUSTOM" style={{ backgroundColor: "#fff3cd", color: "#856404" }}>
              {value}
            </option>
          </>
        )}
      </select>

      {hasValue && !isValueInList && (
        <div
          style={{
            marginTop: 4,
            padding: "6px 8px",
            backgroundColor: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: 4,
            fontSize: "12px",
            color: "#856404",
          }}
        >
          ⚠️ "{value}" - Not found in dropdown list
        </div>
      )}
    </div>
  );
};

export default CountryDropdown;
